import { render } from "./OnboardingPasswordInput.vue?vue&type=template&id=756b4bc3"
import script from "./OnboardingPasswordInput.vue?vue&type=script&lang=js"
export * from "./OnboardingPasswordInput.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__